type ScreenSize = 'desktop' | 'mobile';

export const getWidgetSpacing = {
  vertical: (mq?: ScreenSize) => {
    return mq === 'desktop' ? '1.625rem' : '1rem';
  },
  horizontal: (mq?: ScreenSize) => {
    return mq === 'desktop' ? 0 : '1.25rem';
  },
};
